import ClientLike from "@/api/client-like";
import TaskQueryService from "../entities/task-query-service";
import Task from "../entities/task";
import parseDate from "@/helpers/parseDate";

export default class TaskApi implements TaskQueryService {
  public constructor(private client: ClientLike) {}

  public async all(
    userIds = [],
    staffIds = [],
    userStaffIds = [],
    orderBy: string = ""
  ): Promise<Task[]> {
    const tasks = await this.client.get("get_user_tasks.php", {
      userIds,
      staffIds,
      userStaffIds,
      orderBy
    });
    return tasks.map(this.parseTask);
  }

  public async undone(
    userIds = [],
    staffIds = [],
    userStaffIds = [],
    orderBy: string = ""
  ): Promise<Task[]> {
    const tasks = await this.all(userIds, staffIds, userStaffIds, orderBy);
    return tasks.filter(t => !t.done);
  }

  private parseTask(data: any) {
    return new Task(
      data.taskId,
      data.name,
      data.type,
      data.project,
      data.done,
      data.dueDate ? parseDate(data.dueDate, new Date(), !!data.time) : null,
      data.userName,
      data.date,
      data.time,
      data.users,
      data.projectId,
      data.canEditProject,
      data.isOwner,
      data.canEditName
    );
  }
}
